import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { ethers } from "ethers";
import { createContext } from "react";
import { getDecriptedEnv } from "../../actions/DataActions";
import Config from "../../utils/constants/config";
export const AppContext = createContext();

const getInjectedConnector = () => {
  return Config.ENV == "DEV"
    ? new InjectedConnector({
        supportedChainIds: [5, 80001],
      })
    : new InjectedConnector({
        supportedChainIds: [1],
      });
};

const getWalletConnector = (keys) => {

  keys = getDecriptedEnv(keys);
  const walletconnect =
    Config.ENV == "DEV"
      ? new WalletConnectConnector({
          rpc: {
            5: `${keys?.infura_url}${keys?.infura_key}`,
            80001: `${keys?.infura_url}${keys?.infura_key}`,
          },
          bridge: "https://bridge.walletconnect.org",
          qrcode: true,
          infuraId:keys?.infura_key,
        })
      : new WalletConnectConnector({
          rpc: {
            1: `${keys?.infura_url}${keys?.infura_key}`,
          },
          bridge: "https://bridge.walletconnect.org",
          qrcode: true,
          infuraId: keys?.infura_key,
        });
  return walletconnect;
};

export const getLibrary = (provider) => {
  const library = new ethers.providers.Web3Provider(provider);
  library.pollingInterval = 12000;
  return library;
};

export const connectors = {
  injected:getInjectedConnector,
  walletConnect:getWalletConnector,
};

export function activateInjectedProvider(providerName) {
  const { ethereum } = window;

  if (!ethereum?.providers) {
    return undefined;
  }

  let provider;
  switch (providerName) {
    case "CoinBase":
      provider = ethereum.providers.find(
        ({ isCoinbaseWallet }) => isCoinbaseWallet
      );
      break;
    case "MetaMask":
      provider = ethereum.providers.find(({ isMetaMask }) => isMetaMask);
      break;
  }

  if (provider) {
    ethereum.setSelectedProvider(provider);
  }
}
